import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { getAllPartners, getPartnerClients } from 'redux/modules/partners';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { ListItem } from 'material-ui/List';
import { LeftNavLayout } from 'containers';
import { DataTable, PageHeader, SelectableList, Spinner } from 'components';
import { ClientDetail } from 'containers/Admin';
import * as styles from './Partners.scss';
var PartnerClientDetail = (_dec = connect(function (state) {
  return {
    organization: state.organization.current,
    theme: state.theme,
    allPartners: state.partners.allPartners,
    partnerClients: state.partners.partnerClients,
    gettingPartnerClients: state.partners.gettingPartnerClients,
    isLoadingClient: state.teamManagement.isLoadingClient,
    partnerSearchResults: state.partners.partnerSearchResults
  };
}, {
  getAllPartners: getAllPartners,
  getPartnerClients: getPartnerClients
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(PartnerClientDetail, _Component);

  var _super = _createSuper(PartnerClientDetail);

  function PartnerClientDetail(props) {
    var _this;

    _classCallCheck(this, PartnerClientDetail);

    _this = _super.call(this, props);
    _this.state = {
      height: 100
    };
    return _this;
  }

  _createClass(PartnerClientDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.allPartners && !this.props.allPartners.length) {
        this.props.getAllPartners();
      }

      if (this.props.partnerClients && !this.props.partnerClients.hasOwnProperty(this.props.params.partnerId)) {
        this.props.getPartnerClients(this.props.params.partnerId);
      }
    }
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var headerFields = null;

      var partnerList = _toConsumableArray(this.props.partnerSearchResults || []);

      var partnerListValue = (this.props.partnerSearchResults || []).findIndex(function (partner) {
        return "".concat(partner.orgId) === "".concat(_this2.props.params.partnerId);
      });

      if (partnerListValue === -1) {
        partnerListValue = this.props.allPartners.findIndex(function (partner) {
          return "".concat(partner.orgId) === "".concat(_this2.props.params.partnerId);
        });
        partnerList = _toConsumableArray(this.props.allPartners);
      }

      var clientListValue = this.props.partnerClients && this.props.partnerClients.hasOwnProperty(this.props.params.partnerId) ? this.props.partnerClients[this.props.params.partnerId].findIndex(function (client) {
        return "".concat(client.orgId) === "".concat(_this2.props.params.clientId);
      }) : 0;
      console.log("clientListValue = ".concat(clientListValue));
      return /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "admin",
        wrapStyle: {
          flex: '1 1 auto',
          padding: 0,
          overflow: 'auto'
        },
        appLayoutInnerStyle: {
          display: 'flex',
          flex: '1 1 auto',
          padding: 0,
          overflow: 'hidden',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Partners List"
      }), /*#__PURE__*/React.createElement(Measure, {
        whitelist: ['height'],
        onMeasure: function onMeasure(dimensions) {
          _this2.setState({
            height: dimensions.height
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flex: '0 0 auto',
          height: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid silver',
          flex: '0 0 183px',
          overflow: 'hidden',
          overflowY: 'auto',
          height: this.state.height
        }
      }, partnerList && !!partnerList.length ? /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: partnerListValue + 1,
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, partnerList.map(function (partner, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          value: index + 1,
          primaryText: partner.name,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/global/partners/".concat(partner.orgId)
            });
          }
        });
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          borderRight: '1px solid silver',
          flex: '0 0 183px',
          overflow: 'hidden',
          overflowY: 'scroll',
          height: this.state.height
        }
      }, this.props.partnerClients && this.props.partnerClients.hasOwnProperty(this.props.params.partnerId) && !this.props.gettingPartnerClients ? /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: clientListValue + 1,
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, this.props.partnerClients[this.props.params.partnerId].map(function (client, index) {
        return /*#__PURE__*/React.createElement(ListItem, {
          key: index,
          value: index + 1,
          primaryText: client.name,
          onClick: function onClick() {
            browserHistory.push({
              pathname: "/global/partners/".concat(_this2.props.params.partnerId, "/client/").concat(client.orgId)
            });
          }
        });
      })) : /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }))), /*#__PURE__*/React.createElement(ClientDetail, {
        isPartnerClientListView: true,
        clientId: this.props.params.clientId,
        style: {
          paddingTop: 16
        }
      }))));
    }
  }]);

  return PartnerClientDetail;
}(Component)) || _class);
export { PartnerClientDetail as default };